<template>
  <v-card class="my-4">
    <v-card-title class="card-title-variations"> Estoque </v-card-title>
    <v-row class="px-8">
      <v-divider></v-divider>
    </v-row>
    <v-card-text class="card-stock px-10">
      <v-row>
        <v-col cols="3">
          <h3 class="ma-0">Estoque</h3>
          <p class="mt-0 texto-corrido">Valor atual do estoque desse produto.</p>
          <product-store-price-input
            v-model="productForms.stock"
            remove-prefix
            :validation-error="stockError"
            :validation-message="stockErrorMessage"
            label="Estoque"
          />
        </v-col>
        <v-col cols="6">
          <h3 class="ma-0">Estoque ruptura</h3>
          <p class="mt-0 texto-corrido">Se o estoque chegar ao valor informado neste campo, ele é zerado automaticamente.</p>
          <v-row>
            <v-col class="py-0" cols="6">
              <product-store-price-input
                v-model="productForms.stockBreak"
                remove-prefix
                :validation-error="stockBreakError"
                :validation-message="stockBreakErrorMessage"
                label="Quantidade"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="mt-2">
        <v-col cols="12">
          <h3 class="ma-0">Limite de itens no carrinho</h3>
          <p class="mt-0 texto-corrido">Valor máximo que um consumidor pode adicionar no carrinho em uma compra.</p>
          <v-row>
            <v-col class="py-0" cols="2">
              <v-text-field
                v-model="productForms.sales[getSalesIndex('preco1')].maximumLimit"
                label="Quantidade"
                type="number"
                :error="maximumLimitError"
                :error-messages="maximumLimitErrorMessage"
                outlined
                height="44px"
                @blur="removeSpecialCaracter"
                @keydown="onKeydown"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { preventNonNumericInput } from '@/helpers/validators'
import ProductStorePriceInput from './ProductStorePriceInput.vue'
export default {
  name: 'ProductStoreStock',
  components: { ProductStorePriceInput },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    eanError() {
      return false
    },
    maximumLimitError() {
      return this.validation?.product?.sales.$each[this.getSalesIndex('preco1')].maximumLimit.$error
    },
    stockError() {
      return this.validation?.product?.stock?.$error
    },
    stockBreakError() {
      return this.validation?.product?.stockBreak?.$error
    },
    maximumLimitErrorMessage() {
      if (
        this.validation?.product?.sales.$each[this.getSalesIndex('preco1')].maximumLimit &&
        this.validation?.product?.sales.$each[this.getSalesIndex('preco1')].maximumLimit.$error
      )
        return 'Campo obrigatório'
      return ''
    },
    stockBreakErrorMessage() {
      if (this.validation?.product?.stockBreak?.$error && !this.validation?.product?.stockBreak?.required) return 'Campo obrigatório'
      if (this.validation?.product?.stockBreak?.$error && !this.validation?.product?.stockBreak?.isLessThanStock)
        return 'Estoque de ruptura não pode ser maior que o estoque'
      return ''
    },
    stockErrorMessage() {
      if (this.validation.product.stock && this.validation.product.stock.$error) return 'Campo obrigatório'
      return ''
    },
  },
  watch: {},
  methods: {
    getSalesIndex(salesType) {
      const position = this.productForms.sales.findIndex((sale) => sale.typeEcommerce === salesType)
      return position
    },
    removeSpecialCaracter() {
      if (/-/.test(this.productForms.sales[this.getSalesIndex('preco1')].maximumLimit)) {
        this.productForms.sales[this.getSalesIndex('preco1')].maximumLimit = this.productForms.sales[this.getSalesIndex('preco1')].maximumLimit.replace(
          /[^\w\s]/g,
          ''
        )
      }
    },
    isNumber(evt) {
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      }
    },
    addEans() {
      this.openDialog = true
    },
    onKeydown(event) {
      preventNonNumericInput(event)
    },
  },
}
</script>

<style lang="scss">
.card-stock {
  .v-text-field--filled > .v-input__control > .v-input__slot,
  .v-text-field--full-width > .v-input__control > .v-input__slot,
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 0 !important;
  }

  .v-text-field--outlined .v-label {
    top: 12px !important;
  }

  .v-text-field--enclosed .v-input__append-inner,
  .v-text-field--enclosed .v-input__append-outer,
  .v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field--full-width .v-input__append-inner,
  .v-text-field--full-width .v-input__append-outer,
  .v-text-field--full-width .v-input__prepend-inner,
  .v-text-field--full-width .v-input__prepend-outer {
    margin-top: 11px;
  }
}
</style>
